import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/base',
  component: layout,
  children: ((pre) => [
    {
      path: 'bizDictSet',
      name: `${pre}bizDictSet`,
      meta: {
        ...meta,
        cache: true,
        title: '业务字典维护',
        head: true,
        funcID: 'B0101',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/bizDictSet')
    },
    {
      path: 'warehouseSet',
      name: `${pre}warehouseSet`,
      meta: {
        ...meta,
        cache: true,
        title: '库房信息设置',
        head: true,
        funcID: 'B0102',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/warehouseSet')
    },
    {
      path: 'storageLocationSet',
      name: `${pre}location`,
      meta: {
        ...meta,
        cache: true,
        title: '库位信息维护',
        head: true,
        funcID: 'B0103',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/location')
    },
    {
      path: 'customerSet',
      name: `${pre}customerSet`,
      meta: {
        ...meta,
        cache: true,
        title: '客户档案维护',
        head: true,
        funcID: 'B0104',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/customerSet')
    },
    {
      path: 'customerSet/:pageType/:custCode?',
      name: `${pre}customerSet-detail`,
      meta: {
        ...meta,
        cache: true,
        title: (route) => {
          const types = {
            edit: '编辑客户档案',
            add: '添加客户档案',
            detail: '客户档案详情'
          }
          return types[route.params.pageType]
        },
        head: false,
        funcID: 'B0104',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/customerSet/detail')
    },
    {
      path: 'supplierSet',
      name: `${pre}supplierSet`,
      meta: {
        ...meta,
        cache: true,
        title: '工厂档案维护',
        head: true,
        funcID: 'B0105',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/supplierSet')
    },
    {
      path: 'supplierSet/:pageType/:supCode?',
      name: `${pre}supplierSet-detail`,
      meta: {
        ...meta,
        cache: true,
        title: (route) => {
          const types = {
            edit: '编辑工厂档案',
            add: '添加工厂档案',
            detail: '工厂档案详情'
          }
          return types[route.params.pageType]
        },
        head: false,
        funcID: 'B0105',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/supplierSet/detail')
    },
    {
      path: 'masterColor',
      name: `${pre}masterColor`,
      meta: {
        ...meta,
        cache: true,
        title: '标准颜色维护',
        head: true,
        funcID: 'B0106',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/masterColor')
    },
    {
      path: 'sampleExcipientsTemplateSet',
      name: `${pre}accessories`,
      meta: {
        ...meta,
        cache: true,
        title: '辅料库维护',
        head: true,
        funcID: 'B0107',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/accessories')
    },
    {
      path: 'sampleYarnTemplateSet',
      name: `${pre}yarn`,
      meta: {
        ...meta,
        cache: true,
        title: '纱线库维护',
        head: true,
        funcID: 'B0108',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/yarn')
    },
    {
      path: 'sampleYarnTemplateSet/:pageType/:yarnCode?',
      name: `${pre}yarn-detail`,
      meta: {
        ...meta,
        cache: true,
        title: (route) => {
          const types = {
            edit: '编辑纱线明细信息',
            add: '添加纱线明细信息',
            detail: '纱线信息详情'
          }
          return types[route.params.pageType]
        },
        head: false,
        funcID: 'B0108',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/yarn/detail')
    },
    {
      path: 'port',
      name: `${pre}port`,
      meta: {
        ...meta,
        cache: true,
        title: '港口信息维护',
        head: true,
        funcID: 'B0109',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/base/port')
    },
    {
      path: 'shippingMark',
      name: `${pre}shippingMark`,
      meta: {
        ...meta,
        cache: true,
        title: '唛头信息维护',
        head: true,
        funcID: 'B0110',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/base/shippingMark')
    },
    {
      path: 'expense',
      name: `${pre}expense`,
      meta: {
        ...meta,
        cache: true,
        title: '费用项目维护',
        head: true,
        funcID: 'B0111',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/base/expense')
    },
    {
      path: 'sampleProperties',
      name: `${pre}sampleProperties`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'B0112',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/base/sampleProperties')
    },
    {
      path: 'goodsInputStandards',
      name: `${pre}goodsInputStandards`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'B0114',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/base/goodsInputStandards')
    },
  ])('master-')
}
